import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const MQ_NO_SIDEBAR = 'medium';
export const MQ_NO_TITLE = 'small';

export const MtLayoutTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  margin-bottom: 24px;

  & > * {
    width: auto !important;
    margin-bottom: 0 !important;
  }
`;

export const MtLayouTitleEditButtonContainer = styled.div`
  display: flex;
  align-items: center;
  font-family: ${(props) => props.theme.font.default} !important;
  gap: 14px;

  ${mediaQuery(BREAKPOINTS.small)} {
    flex-direction: column;
    align-items: end;
  }
`;

export const MtLayouTitleBackButton = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: ${(props) => props.theme.color.dark.default};
  font-family: ${(props) => props.theme.font.default} !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  white-space: nowrap;

  & > *:not(:last-child) {
    margin-right: 5px;
  }
`;

export const MtLayouTitleEditButton = styled.div<{ color?: 'red' | 'blue' | 'medium' | 'dark' }>`
  font-weight: 700;
  font-size: 14px;
  color: ${(props) => props.theme.color[props.color ?? 'blue'].default};
  font-family: ${(props) => props.theme.font.default} !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
  white-space: nowrap;

  & > *:not(:last-child) {
    margin-right: 5px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  height: 100%;

  display: grid;
  grid-template-rows: 72px 1fr;
  grid-template-columns: 270px 1fr;
  grid-template-areas:
    'side header'
    'side content';

  ${mediaQuery(MQ_NO_SIDEBAR)} {
    grid-template-columns: 0px 1fr;
  }
`;

export const SideWrapper = styled.div`
  overflow-y: auto;
  grid-area: side;
  background: ${(props) => props.theme.color.light.default};
  color: ${(props) => props.theme.color.medium.shade};
  position: relative;
  z-index: 1;

  ${mediaQuery(MQ_NO_SIDEBAR)} {
    display: none;
  }
`;

export const Header = styled.header`
  grid-area: header;
  background: ${(props) => props.theme.color.light.default};
  padding: 0 24px;
  box-shadow: 0px 1px 0px #f0f0f0;
  position: relative;
  z-index: 10;
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderRightContainer = styled.div`
  & > *:not(:last-child) {
    margin-right: 25px;
  }
  display: flex;
  align-items: center;
  ${mediaQuery(MQ_NO_SIDEBAR)} {
    display: none;
  }
`;

export const HeaderTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderTitle = styled.h2`
  color: ${(props) => props.theme.color.dark.shade};
  font-family: ${(props) => props.theme.font.default};
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  margin-left: 17px;
  display: none;

  ${mediaQuery(MQ_NO_TITLE, 'min')} {
    display: block;
  }

  ${mediaQuery(MQ_NO_SIDEBAR, 'min')} {
    margin-left: 0;
  }
`;

export const HeaderLogoWrapper = styled.div`
  height: 50px;
  & > img {
    height: 100%;
  }
  ${mediaQuery(MQ_NO_SIDEBAR, 'min')} {
    display: none;
  }
`;

export const HeaderProfileWrapper = styled.div`
  cursor: pointer;
  position: relative;
  padding: 4px 8px;
  border-radius: 12px;
  &:hover {
    background-color: ${(props) => props.theme.color.light.tint};
  }
  &:hover [data-dropdown-content] {
    height: auto;
    opacity: 1;
  }
`;

export const HeaderProfileContent = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  padding: 18px 0;
`;

export const HeaderProfileImage = styled.div`
  margin-right: 15px;
`;

export const HeaderDropdownProgressWrapper = styled.div`
  margin-left: 10px;
`;

export const HeaderDropdownIconWrapper = styled.div`
  margin-left: 10px;
  font-size: 14px;
`;

export const HeaderDropdownContent = styled.div`
  overflow: hidden;
  height: 0;
  opacity: 0;
  transition: height 0ms 300ms, opacity 300ms 0ms;
  background: ${(props) => props.theme.color.light.default};
  position: absolute;
  z-index: 10;
  right: 0;
  top: 100%;
  border-radius: 10px;
  min-width: 250px;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.08);
`;

export const HeaderDropdownLink = styled.div<{ disabled?: string }>`
  color: ${(props) => props.theme.color.medium.shade};
  transition: background 0.3s ease-in-out;
  padding: 20px;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  cursor: pointer;

  &:not(:first-of-type) {
    border-top: ${(props) => `1px solid ${props.theme.color.light.shadeLighter}`};
  }

  &:hover,
  &:focus {
    background: ${(props) => props.disabled === 'false' && props.theme.color.light.tint};
  }

  ${(props) =>
    props.disabled === 'true' && `cursor: not-allowed; color: ${props.theme.color.medium.tint}`};
  '}
`;

export const HeaderDropdownIcon = styled(FontAwesomeIcon)`
  margin-right: 4px;
`;

export const ContentWrapper = styled.div<{ noPadding?: boolean }>`
  grid-area: content;
  overflow: auto;
  height: 100%;
  min-height: min-content;
  ${(props) => !props.noPadding && 'padding: 24px 0;'}
`;

//
// SIDE
//
export const SideLogoWrapper = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0px 1px 0px #f0f0f0;
  & > img {
    height: 80px;
  }
`;

export const SideNavigationWrapper = styled.div`
  padding: 24px;
  height: calc(100% - 72px);
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${(props) => props.theme.color.light.shadeLighter};
`;
